var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94881 9.72058L9.17153 9.17161L8.22895 8.22903L8.45268 8.01634C10.808 5.88819 14.4443 5.95907 16.7142 8.22903C19.0571 10.5722 19.0573 14.3712 16.7142 16.7143C14.3712 19.0574 10.5721 19.0572 8.22895 16.7143C7.08861 15.574 6.4722 14.0545 6.47154 12.4737C6.47127 12.1057 6.17257 11.8079 5.80448 11.8081C5.43632 11.8082 5.13801 12.1063 5.13812 12.4744C5.13892 14.4051 5.89355 16.2641 7.28637 17.6569C10.1502 20.5205 14.793 20.5207 17.6568 17.6569C20.5206 14.7931 20.5204 10.1503 17.6568 7.28645C14.793 4.4226 10.1495 4.42191 7.28568 7.28576L6.3431 6.34318L5.94881 9.72058Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.80ed20da52f2d63c5e197b01a4093786.svg";
export { ForwardRef as ReactComponent };